<template>
  <div class="service_process" :class="{ more: routerAction }">
    <van-steps direction="vertical">
      <template v-for="(item, index) in serviceList">
        <van-step
          :key="index"
          v-if="index < shownum"
          :class="{ detail: routerAction }"
        >
          <p>
            <span class="service_time">
              {{ $$dateFormat(item.applyHouseHoldTime, 'YY.MM') }}
              -
              {{ $$dateFormat(item.writeoffTime, 'YY.MM') }}
            </span>
            <span>
              <!-- <img
                                v-if="routerAction"
                                src="../../../../assets/images/icon-arr-r@3x.png"
                                alt=""
                            /> -->
              <img
                v-if="routerAction"
                src="../../../../assets/images/sx_icon_more@3x.png"
                alt=""
              />
              <span
                class="service_comment"
                @click="goComment(item.commentId, item.workerCode)"
                >查看评价</span
              >
            </span>
          </p>

          <p>
            <span class="service_customer">服务对象：</span>
            {{ item.nickName }}
            <span
              v-if="item.sendBannerNum"
              :class="{ send_num: item.sendBannerNum }"
              >(赠送{{ item.sendBannerNum }}面锦旗)</span
            >
          </p>
          <p>
            <span class="service_address">服务地址：</span>
            {{ item.address }}
          </p>
          <p v-if="routerAction">
            <span class="service_time">服务时长：</span>
            {{ item.serviceTime }}天
          </p>
        </van-step>
      </template>
    </van-steps>
  </div>
</template>

<script>
import { Step, Steps } from 'vant'
export default {
  components: {
    [Step.name]: Step,
    [Steps.name]: Steps
  },
  props: {
    serviceList: Array,
    shownum: {
      default: Infinity,
      type: Number
    },
    routerAction: Boolean
  },
  methods: {
    goComment(commentId, workerCode) {
      this.$router.push({
        path: '/evaluate',
        query: {
          commentId,
          workerCode,
          ht: 'look'
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/mixin.scss';
.service_process {
  padding: rem(30px) 0 rem(6px) 0;
  .van-step--vertical {
    padding: 0;
  }
  /deep/.van-step__title {
    width: rem(616px);
    padding: 0 rem(48px) rem(20px) rem(49px);
    margin: 0 0 rem(24px) 0;
    height: 100%;
    background-image: url('../../../../assets/images/service_bg@3x.png');
    background-size: rem(616px) 100%;
    p:nth-child(1) {
      margin-bottom: rem(20px);
      height: rem(62px);
      overflow: hidden;
      padding-top: rem(20px);

      .service_time {
        float: left;
        font-family: PingFangSC-Medium;
        font-size: rem(28px);
        height: rem(37px);
        color: #121212;
        font-weight: 500;
      }
      .service_comment {
        float: right;
        height: rem(33px);
        line-height: rem(32px);
        font-family: PingFangSC-Regular;
        font-size: rem(24px);
        color: #999999;
        text-align: right;
        font-weight: 400;
      }

      img {
        float: right;
        margin-top: rem(7px);
        width: rem(20px);
        height: rem(20px);
      }
    }
    p:nth-child(2) {
      height: rem(37px);
      color: #4d4d4d;
      .service_customer {
        height: rem(40px);
        line-height: rem(40px);
        font-family: PingFangSC-Medium;
        font-size: rem(26px);
      }
      .send_num {
        font-size: rem(28px);
        color: #ff397e;
      }
    }
    p:nth-child(3) {
      margin-top: rem(8px);
      color: #4d4d4d;
      .service_address {
        height: rem(40px);
        line-height: rem(40px);
        font-family: PingFangSC-Medium;
        font-size: rem(26px);
      }
    }
  }

  .detail {
    /deep/.van-step__title {
      width: rem(651.57px);
      height: 100%;
      background-image: url('../../../../assets/images/service_bg@3x.png');
      background-size: rem(651.57px) 100%;

      p:nth-child(1) {
        overflow: hidden;
        .service_comment {
          float: right;
        }
      }

      p:nth-child(4) {
        margin-top: rem(8px);
        color: #4d4d4d;
        .service_address {
          height: rem(40px);
          font-family: PingFangSC-Medium;
          font-size: rem(26px);
          line-height: rem(40px);
        }
      }
    }
  }

  .van-step--vertical:not(:last-child)::after {
    border-bottom-width: 0;
  }

  .van-icon-checked::before {
    content: '';
  }

  /deep/.van-step__circle {
    width: rem(18px);
    height: rem(18px);
    background: #ffffff;
    background-image: url('../../../../assets/images/service_circle@3x.png');
    background-size: rem(18px);
  }

  /deep/.van-icon-checked::before {
    content: '';
    width: rem(18px);
    height: rem(18px);
    background: #ffffff;
    background-image: url('../../../../assets/images/service_circle@3x.png');
    background-size: rem(18px);
  }

  /deep/ .van-step--vertical .van-step__line {
    width: rem(4px);
    left: rem(-32px);
    height: 110%;
  }

  /deep/.van-step:last-child .van-step__line {
    width: 0 !important;
  }

  /deep/ .van-step__line {
    background-color: #f4f5f3;
  }
}

.more {
  /deep/.van-step__title p:nth-child(1) {
    .service_comment {
      color: #262626;
    }

    img {
      margin-left: rem(2px);
    }
  }

  /deep/ .van-step__title {
    padding: 0 rem(24px) rem(20px) rem(49px);
  }
}
</style>
